"use client";

import { ReactNode, useCallback } from "react";
import { useRouter } from "@onclicks/sharedmobilei18n/routing";
import { ConversationsProvider } from "./conversations-provider";
import { useMessageriePath } from "../hooks/use-messagerie-path";
import { Conversation } from "../types/models/conversation";
import { coursesPath } from "../paths/paths";

/**
 * Branche le temps réel sur la navigation de l'application : une notification
 * de message doit mener au fil concerné, une notification de course à sa fiche.
 *
 * Cette couche existe pour que `ConversationsProvider` reste ignorant du
 * routage — il ne sait rien des chemins client/back-office, qui dépendent des
 * rôles du compte connecté.
 */
export const MessagerieProvider = ({ children }: { children: ReactNode }) => {
  const router = useRouter();
  const { cheminMessagerie } = useMessageriePath();

  const ouvrirMessagerie = useCallback(
    (conversation: Conversation) =>
      router.push(`${cheminMessagerie}?fil=${conversation.id}`),
    [cheminMessagerie, router],
  );

  // Toujours la fiche back-office : ces notifications ne sont diffusées qu'aux
  // gestionnaires, un client n'en reçoit aucune et n'atteindra donc jamais ce
  // chemin.
  const ouvrirCourse = useCallback(
    (idCourse: number) => router.push(`${coursesPath}/${idCourse}/view`),
    [router],
  );

  return (
    <ConversationsProvider
      ouvrirMessagerie={ouvrirMessagerie}
      ouvrirCourse={ouvrirCourse}
    >
      {children}
    </ConversationsProvider>
  );
};
